import classNames from 'classnames'
import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { formatThousandsSeparator } from 'helpers/others.helper'
import { useAnimatedNumbers } from 'hooks/useAnimatedNumbers'
import Progress from '../Progress'
import ProgressPopover from '../ProgressPopover'
import { Card } from './Card'

import styles from './Cards.module.scss'

interface CardsProps {
  title: React.ReactNode
  total: number
  finish: number
  inProgress: number
  pending: number
  className?: string
}

export const Cards: React.FC<CardsProps> = ({
  title,
  total,
  finish,
  inProgress,
  pending,
  className,
}) => {
  const { i18n } = useTranslation()
  const animatedTotal = useAnimatedNumbers({ total }).total
  const animatedProgress = useAnimatedNumbers({ finish, inProgress, pending })

  return (
    <Row
      className={classNames(
        styles.cards,
        className,
        'align-content-center mx-0'
      )}
    >
      <Card cardClassName={classNames(styles.areas, styles.cardTotal)}>
        <div className={styles.content}>{title}</div>
        <div className={styles.total}>
          {formatThousandsSeparator(animatedTotal, i18n.language)}
        </div>
      </Card>
      <ProgressPopover
        id={`cards-progress-${String(title)}`}
        progress={{
          finish: animatedProgress.finish,
          inProgress: animatedProgress.inProgress,
          pending: animatedProgress.pending,
        }}
        component={Col}
        className={classNames('align-items-center d-flex', styles.progressCol)}
      >
        <Progress
          finish={animatedProgress.finish}
          inProgress={animatedProgress.inProgress}
          pending={animatedProgress.pending}
          className={styles.progressBar}
          classes={{
            finish: styles.progressFinish,
            inProgress: styles.progressInProgress,
            pending: styles.progressPending,
          }}
        />
      </ProgressPopover>
    </Row>
  )
}

export default Cards
